export type BpmnShapeId =
  | 'bpmn-event'
  | 'bpmn-gateway'
  | 'bpmn-activity'
  | 'bpmn-data'
  | 'bpmn-data-store'
  | 'bpmn-annotation';

export interface BpmnShapeDef {
  id: BpmnShapeId;
  width: number;
  height: number;
  strokeWidth: number;
  paths: string[];
  fillPaths?: string[];
  text?: string;
}

export const BPMN_SHAPES: Record<BpmnShapeId, BpmnShapeDef> = {
  'bpmn-event': {
    id: 'bpmn-event',
    width: 60,
    height: 60,
    strokeWidth: 1.6,
    text: 'Event',
    paths: [
      'M24.7998 48.8C38.0546 48.8 48.7998 38.0549 48.7998 24.8C48.7998 11.5452 38.0546 0.800049 24.7998 0.800049C11.545 0.800049 0.799805 11.5452 0.799805 24.8C0.799805 38.0549 11.545 48.8 24.7998 48.8Z',
    ],
  },
  'bpmn-gateway': {
    id: 'bpmn-gateway',
    width: 124,
    height: 62,
    strokeWidth: 1.6,
    text: 'Gateway',
    paths: [
      'M61.7891 0.894409L121.789 30.8944L61.7891 60.8944L1.78906 30.8944L61.7891 0.894409Z',
    ],
  },
  'bpmn-activity': {
    id: 'bpmn-activity',
    width: 120,
    height: 84,
    strokeWidth: 1.6,
    text: 'Activity',
    paths: [
      'M108.8 1.59998H11.2001C5.89816 1.59998 1.6001 5.89804 1.6001 11.2V72.8C1.6001 78.1019 5.89816 82.4 11.2001 82.4H108.8C114.102 82.4 118.4 78.1019 118.4 72.8V11.2C118.4 5.89804 114.102 1.59998 108.8 1.59998Z',
    ],
  },
  'bpmn-data': {
    id: 'bpmn-data',
    width: 62,
    height: 62,
    strokeWidth: 1.6,
    text: 'Data',
    paths: [
      'M48.7998 0.800049V8.80005C48.7998 11.0092 50.5907 12.8 52.7998 12.8H60.7998M4.7998 60.8001H56.7998C59.0089 60.8001 60.7998 59.0092 60.7998 56.8001V14.4569C60.7998 13.396 60.3784 12.3786 59.6282 11.6285L49.9714 1.97162C49.2212 1.22148 48.2038 0.800049 47.143 0.800049H4.79981C2.59067 0.800049 0.799805 2.59091 0.799805 4.80005V56.8001C0.799805 59.0092 2.59067 60.8001 4.7998 60.8001Z',
    ],
  },
  'bpmn-data-store': {
    id: 'bpmn-data-store',
    width: 100,
    height: 80,
    strokeWidth: 1.6,
    text: 'DataStore',
    fillPaths: [
      'M12.5 16.6667L12.5 63.3333C12.5 68.8562 29.2893 73.3333 50 73.3333C70.7108 73.3333 87.5 68.8562 87.5 63.3333L87.5 16.6667C87.5 11.1438 70.7108 6.6667 50 6.6667C29.2893 6.6667 12.5 11.1438 12.5 16.6667Z',
    ],
    paths: [
      'M50 26.6667C70.7108 26.6667 87.5 22.1895 87.5 16.6667C87.5 11.1438 70.7108 6.6667 50 6.6667C29.2893 6.6667 12.5 11.1438 12.5 16.6667C12.5 22.1895 29.2893 26.6667 50 26.6667Z',
      'M12.5 16.6667V63.3333C12.5 68.8562 29.2893 73.3333 50 73.3333C70.7108 73.3333 87.5 68.8562 87.5 63.3333V16.6667',
    ],
  },
  'bpmn-annotation': {
    id: 'bpmn-annotation',
    width: 78,
    height: 62,
    strokeWidth: 1.6,
    text: 'Annotation',
    paths: [
      'M16.8 0.800049V60.8001M16.8 0.800049H30.8M16.8 60.8001H30.8',
    ],
  },
};

export const BPMN_SHAPE_IDS: BpmnShapeId[] = [
  'bpmn-event',
  'bpmn-gateway',
  'bpmn-activity',
  'bpmn-data',
  'bpmn-data-store',
  'bpmn-annotation',
];
